export const APP_NAME = 'Superfile';
export const APP_DESCRIPTION = 'A fantastic SaaS to make your life easier.';
